<template>
  <div class="container">
    <div class="buttongroup">
      <a-button type="primary" @click="addUser()">添加用户</a-button>
      <a-modal width="1000px" v-model="addUserVisible" title="添加用户" @ok="this.addUserVisible = false">
        <div class="searchBar">
          <a-input v-model="searchUserID" placeholder="用户账号" style="width: 200px" />
          <a-button type="primary" icon="search" style="margin-left: 10px" @click="search()">搜索</a-button>
        </div>
        <a-table
          :columns="userColumns"
          :data-source="userData"
          :pagination="false"
          :loading="loading"
          bordered
          style="margin-top: 10px"
        >
          <span slot="action" slot-scope="text, record">
            <a-button type="link" @click="addToSource(record)" size="small">添加</a-button>
          </span>
        </a-table>
        <div style="height: 2rem">
          <a-pagination
            size="small"
            style="margin-top: 1%; float: right; height: 50px"
            :current="userPagination.current"
            :total="userPagination.total"
            :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
            show-size-changer
            show-quick-jumper
            :showSizeChanger="true"
            :pageSize="userPagination.pageSize"
            :pageSizeOptions="userPagination.pageSizeOptions"
            @change="onUserChange"
            @showSizeChange="showUserSizeChange"
          />
        </div>
      </a-modal>
    </div>
    <div class="tableBar">
      <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" bordered>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" style="color: #ff4d4f" @click="deleteUser(record)" size="small">删除</a-button>
        </span>
      </a-table>
    </div>
    <div class="pageBar">
      <a-pagination
        size="small"
        style="margin-top: 1%; float: right"
        :current="pagination.current"
        :total="pagination.total"
        :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
        show-size-changer
        show-quick-jumper
        :showSizeChanger="true"
        :pageSize="pagination.pageSize"
        :pageSizeOptions="pagination.pageSizeOptions"
        @change="onChange"
        @showSizeChange="showSizeChange"
      />
    </div>
    <a-button @click="closeDrawerToFather()">关闭</a-button>
  </div>
</template>

<script>
import { getSourceAllUser, searchUser, delSourceUser, addSourceUser } from '@/api/api'

const columns = [
  {
    title: '用户账号',
    dataIndex: 'username',
    key: 'username',
    width: 80,
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    key: 'phone',
    width: 100,
  },
  {
    title: '名字',
    dataIndex: 'realname',
    key: 'realname',
    width: 100,
  },
  {
    title: '添加人',
    dataIndex: 'createBy',
    key: 'createBy',
    width: 80,
  },
  {
    title: '添加时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 70,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: 80,
  },
]

export default {
  props: {
    sourcesid: {
      type: String,
    },
  },
  data() {
    return {
      columns,
      data: [],
      userData: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      userPagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      loading: false,
      userLoading: false,
      sourcesID: '',
      addUserVisible: false,
      searchUserID: '',
      userColumns: [
        {
          title: '用户账号',
          dataIndex: 'username',
          key: 'username',
          width: 50,
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          key: 'phone',
          width: 50,
        },
        {
          title: '名字',
          dataIndex: 'realname',
          key: 'realname',
          width: 80,
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 80,
        },
      ],
    }
  },
  watch: {
    sourcesid: 'updateSourceId',
  },
  mounted() {
    this.sourcesID = this.sourcesid
    this.getTableDate()
  },
  methods: {
    addToSource(data) {
      let requestDate = {
        sourceId: this.sourcesID,
        userId: data.id,
        userName: this.$ls.get('Login_Userinfo').realname,
      }
      addSourceUser(requestDate).then((res) => {
        if (res.success) {
          this.addUserVisible = false
          this.$message.success(res.message)
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onUserChange(page, pageSize) {
      this.userPagination.current = page
      this.userPagination.pageSize = pageSize
      this.addUser()
    },
    showUserSizeChange(current, size) {
      this.userPagination.current = current
      this.userPagination.pageSize = size
      this.addUser()
    },
    search() {
      this.userPagination.current = 1
      let getUserRequest = {
        pageNum: this.userPagination.current,
        pageSize: this.userPagination.pageSize,
        userId: this.searchUserID,
      }
      searchUser(getUserRequest).then((res) => {
        this.userData = res.result.records
        this.userPagination.current = res.result.current
        this.userPagination.total = res.result.total
        this.userLoading = false
      })
    },
    addUser() {
      this.addUserVisible = true
      let getUserRequest = {
        pageNum: this.userPagination.current,
        pageSize: this.userPagination.pageSize,
        userId: this.searchUserID,
      }
      searchUser(getUserRequest).then((res) => {
        this.userData = res.result.records
        this.userPagination.current = res.result.current
        this.userPagination.total = res.result.total
        this.userLoading = false
      })
    },
    getTableDate() {
      let requestParms = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sourceId: this.sourcesID,
      }
      getSourceAllUser(requestParms).then((res) => {
        this.data = res.result.records
        this.pagination.current = res.result.current
        this.pagination.total = res.result.total
        this.loading = false
      })
    },
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getTableDate()
    },
    //修改页容量触发方法
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getTableDate()
    },
    updateSourceId() {
      this.sourcesID = this.sourcesid
      this.getTableDate()
    },
    closeDrawerToFather() {
      this.$emit('closeSourcesDrawer', false)
    },
    deleteUser(user) {
      this.$antdConfirm({
        title: '是否删除名字为：' + user.realname + '的用户?',
        content: (h) => (
          <div style="color:red;">
            <a-icon type="info-circle" style="margin-right:10px" />
            删除操作不可恢复的哦
          </div>
        ),
        okText: '是',
        okType: 'danger',
        cancelText: '点错啦',
        onOk: () => {
          this.doDelete(user.id)
        },
        onCancel: () => {
          this.$message.success('感谢您的仁慈！')
        },
      })
    },
    doDelete(id) {
      let request = {
        id: id,
      }
      delSourceUser(request).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>
<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  background-color: #ffffff;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.tableBar {
  margin-top: 30px;
}
</style>
